var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from 'react';
const SvgComponent = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 50,
  height: 30,
  viewBox: "0 0 35 34"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "none",
  fillRule: "nonzero",
  stroke: "#000",
  d: "M9.565 7.017l-2.67-2.676-2.109 2.11 2.676 2.676 2.103-2.11zm-4.108 8.431H.984v2.982h4.473v-2.982zM18.875.614h-2.982v4.398h2.982V.614zM29.982 6.45l-2.11-2.11-2.675 2.677 2.11 2.11 2.675-2.677zm-4.778 20.41l2.676 2.677 2.11-2.11-2.676-2.676-2.11 2.11zm4.107-11.412v2.982h4.473v-2.982h-4.473zM17.384 7.994a8.943 8.943 0 0 0-8.945 8.945 8.943 8.943 0 0 0 8.945 8.945 8.943 8.943 0 0 0 8.946-8.945 8.943 8.943 0 0 0-8.946-8.945zm-1.49 25.27h2.981v-4.398h-2.982v4.398zM4.785 27.427l2.11 2.11 2.676-2.676-2.11-2.11-2.676 2.676z"
})));
export default __webpack_public_path__ + "teg/media/sunlight.cb802681.svg";
export { SvgComponent as ReactComponent };